import { apiClientWithRefreshToken } from "@/api/apiClient";
import { CreateUserSchema } from "@/v2/schema/members";
import { User } from "@/v2/types";

export default async function CreateUser(
    data: CreateUserSchema,
): Promise<User> {
    const formData = new FormData();

    formData.append("email", data?.email ?? "");
    formData.append("full_name", data?.full_name ?? "");
    formData.append("phone_number", data?.phone_number ?? "");
    formData.append("is_admin", String(data?.is_admin ?? false));
    formData.append("assigned_employee_id", data?.assigned_employee_id ?? "");

    for (const role of data.roles) {
        formData.append("roles", role);
    }

    if (data?.password) {
        formData.append("password", data.password);
    }

    const res = await apiClientWithRefreshToken({
        url: "/register",
        method: "POST",
        data: formData,
    });

    return res.data;
}
